export const GET_EMP_CHECKLIST = 'GET_EMP_CHECKLIST';
export const LOADING_EMP_CHECKLIST = 'LOADING_EMP_CHECKLIST';
export const SAVE_LOADER_EMP_CHECKLIST = 'SAVE_LOADER_EMP_CHECKLIST';